export enum WebglOverlayTextBoxCalloutTriangleSide {
  bottom = 'bottom',
}

export const WEBGL_LABEL_NEW_LINE = '\n';
